import type { LocalDatabaseSupplier } from "../../../_Generated/Sync.gen";
import type { BaseSupplierRepository } from "../../_Bases/BaseSupplierRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBSupplierRepository extends BaseIndexedDBRepository<
    LocalDatabaseSupplier
> implements BaseSupplierRepository {
    public readonly source: InternalIndexedDBDatabase["suppliers"];
    protected readonly dataTypeName = "Supplier";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.suppliers;
    }

    public search(value: string): Promise<Array<LocalDatabaseSupplier>> {
        const needle = value.trim().toLowerCase();

        if(!needle) {
            return this.all();
        }

        return this.source
            .filter((supplier) => {
                return supplier.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
